import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import Rating from 'react-star-rating-component';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from 'jquery';

class Comp3 extends Component {
  constructor() {
    super();
    this.state = {
      name: "ReactJS",
      ratinginfo: ''
    };

    this.next_ratings = this.next_ratings.bind(this);
    this.previous_ratings = this.previous_ratings.bind(this);
  }

  componentDidMount() {

    let info = this.props.paraminfo;
    this.setState({ ratinginfo: info });
  }

  next_ratings() {
    this.slider_ratings.slickNext();
  }
  previous_ratings() {
    this.slider_ratings.slickPrev();
  }

  triggerReview = () => {
    document.getElementById("review-btn").click();
  }

  render() {

    const ratingmbscrlsettings = {
      dots: true,
      infinite: false,
      speed: 500,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
    };

    return <div id="ratings_section">
      <h3 className="pointer" onClick={this.triggerReview}>Ratings        
      </h3>
      <div class="aboutinfo">
        <div className='col-md-12 n6-desc custom-margin-bottom desktop'>
          <div className='row ratingsblock'>

           
            <div className='col-md-4'>
              <div className='' style={{ float: "left" }}>Teachers</div>
              <div className='key-po-rating'>{(this.state.ratinginfo.qty_teachers != 'NaN') ? this.state.ratinginfo.qty_teachers : '0.0'}</div>
            </div>
            <div className='col-md-4'>
              <div className='' style={{ float: "left" }}>Teaching Methods</div>
              <div className='key-po-rating'>{(this.state.ratinginfo.qty_teaching != 'NaN') ? this.state.ratinginfo.qty_teaching : '0.0'}</div>
            </div>
            <div className='col-md-4'>
              <div className='' style={{ float: "left" }}>Other Staff Interaction</div>
              <div className='key-po-rating'>{(this.state.ratinginfo.qty_interaction != 'NaN') ? this.state.ratinginfo.qty_interaction : '0.0'}</div>
            </div>
            <div className='col-md-4'>
              <div className='' style={{ float: "left" }}>Child Safety</div>
              <div className='key-po-rating'>{(this.state.ratinginfo.child_safety != 'NaN') ? this.state.ratinginfo.child_safety : '0.0'}</div>
            </div>
            <div className='col-md-4'>
              <div className='' style={{ float: "left" }}>Information @ Website</div>
              <div className='key-po-rating'>{(this.state.ratinginfo.qty_info_website != 'NaN') ? this.state.ratinginfo.qty_info_website : '0.0'}</div>
            </div>
            <div className='col-md-4'>
              <div className='' style={{ float: "left" }}>Campus & Facilities</div>
              <div className='key-po-rating'>{(this.state.ratinginfo.facilities != 'NaN') ? this.state.ratinginfo.facilities : '0.0'}</div>
            </div>
            <div className='col-md-4'>
              <div className='' style={{ float: "left" }}>Transport arrangement</div>
              <div className='key-po-rating'>{(this.state.ratinginfo.transport_arrange != 'NaN') ? this.state.ratinginfo.transport_arrange : '0.0'}</div>
            </div>

            <div className='col-md-4'>
              <div className='' style={{ float: "left" }}>Teacher : Students Ratio</div>
              <div className='key-po-rating'>{(this.state.ratinginfo.teacher_student_ratio != 'NaN') ? this.state.ratinginfo.teacher_student_ratio : '0.0'}</div>
            </div>
            <div className='col-md-4'>
              <div className='' style={{ float: "left" }}>Overall Rating</div>
              <div className='key-po-rating'>{(this.state.ratinginfo.overall_expirence != 'NaN') ? this.state.ratinginfo.overall_expirence : '0.0'}</div>
            </div>

          </div>
        </div>
        <div className='col-md-12 custom-margin-bottom mobileonly'>
          <div className='ratingsliders'>

            <Slider  ref={c => (this.slider_ratings = c)} {...ratingmbscrlsettings} >

            <div className='cardblock'>

<div class="stacklist">
  <div className='' style={{ float: "left" }}>Campus & Facilities</div>
  <div className='key-po-rating'>{(this.state.ratinginfo.facilities != 'NaN') ? this.state.ratinginfo.facilities : '0.0'}</div>
</div>
<div class="stacklist">
  <div className='' style={{ float: "left" }}>Transport arrangement</div>
  <div className='key-po-rating'>{(this.state.ratinginfo.transport_arrange != 'NaN') ? this.state.ratinginfo.transport_arrange : '0.0'}</div>
</div>
<div class="stacklist">
  <div className='' style={{ float: "left" }}>Teacher : Students Ratio</div>
  <div className='key-po-rating'>{(this.state.ratinginfo.teacher_student_ratio != 'NaN') ? this.state.ratinginfo.teacher_student_ratio : '0.0'}</div>
</div>
<div class="stacklist">
  <div className='' style={{ float: "left" }}>Overall Rating</div>
  <div className='key-po-rating'>{(this.state.ratinginfo.overall_expirence != 'NaN') ? this.state.ratinginfo.overall_expirence : '0.0'}</div>
</div>

</div>

              


              <div className='cardblock'>

                <div class="stacklist">
                  <div className='' style={{ float: "left" }}>Other Staff Interaction</div>
                  <div className='key-po-rating'>{(this.state.ratinginfo.qty_interaction != 'NaN') ? this.state.ratinginfo.qty_interaction : '0.0'}</div>
                </div>
                <div class="stacklist">

                  <div className='' style={{ float: "left" }}>Child Safety</div>
                  <div className='key-po-rating'>{(this.state.ratinginfo.child_safety != 'NaN') ? this.state.ratinginfo.child_safety : '0.0'}</div>

                </div>
                <div class="stacklist">

                  <div className='' style={{ float: "left" }}>Information @ Website</div>
                  <div className='key-po-rating'>{(this.state.ratinginfo.qty_info_website != 'NaN') ? this.state.ratinginfo.qty_info_website : '0.0'}</div>

                </div>

              </div>

              <div className='cardblock'>

               

                <div class="stacklist">

                  <div className='' style={{ float: "left" }}>Teachers</div>
                  <div className='key-po-rating'>{(this.state.ratinginfo.qty_teachers != 'NaN') ? this.state.ratinginfo.qty_teachers : '0.0'}</div>

                </div>
                <div class="stacklist">

                  <div className='' style={{ float: "left" }}>Teaching Methods</div>
                  <div className='key-po-rating'>{(this.state.ratinginfo.qty_teaching != 'NaN') ? this.state.ratinginfo.qty_teaching : '0.0'}</div>

                </div>


              </div>

              


            </Slider>
             
          </div>
        </div>

      </div>
    </div>
  }
}

export default Comp3;